import { UserDashboardQuery } from '@website/types/graphqlOperations';

/**
 * getBookingsFromGuestOnBooking
 *
 * get bookings from guestsOnBooking object
 *
 **/
export function getBookingsFromGuestOnBooking(
  guestOnBookings: UserDashboardQuery['user']['guestOnBookings']['items'],
) {
  return guestOnBookings.map((guestOnBooking) => guestOnBooking.booking);
}
